<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<h2 class="bd-title">Site Settings</h2>
<p class="text-muted">
  <small><em>All fields are required unless specified optional</em></small>
</p>
<coso-select-input [control]="formGroup.controls.pattern" [inputText]="formText.pattern" [readonly]="isReadOnly$ | async"></coso-select-input>
@if (formGroup.controls.pattern.value != SiteRule.None) {
<coso-text-input type="text" [control]="formGroup.controls.webTemplate" [inputText]="formText.webTemplate" [readonly]="isReadOnly$ | async"></coso-text-input>
<coso-select-input [control]="formGroup.controls.language" [inputText]="formText.language" [readonly]="isReadOnly$ | async"></coso-select-input>
} @if (formGroup.controls.pattern.value == SiteRule.Period) {
<coso-select-input [control]="formGroup.controls.period" [inputText]="formText.period" [readonly]="isReadOnly$ | async"></coso-select-input>
<coso-select-input [control]="formGroup.controls.periodSource" [inputText]="formText.periodSource" [readonly]="isReadOnly$ | async"></coso-select-input>
} @if ( (formGroup.controls.pattern.value == SiteRule.Period && formGroup.controls.period.value == Period.Custom) || formGroup.controls.pattern.value == SiteRule.PerRecord ||
formGroup.controls.pattern.value == SiteRule.StartingNameChars || formGroup.controls.pattern.value == SiteRule.StartingIdChars ) {
<coso-text-input type="text" [control]="formGroup.controls.namePattern" [inputText]="formText.namePattern" [readonly]="isReadOnly$ | async"></coso-text-input>
} @if (formGroup.controls.pattern.value == SiteRule.StartingNameChars || formGroup.controls.pattern.value == SiteRule.StartingIdChars) {
<coso-text-input type="number" [control]="formGroup.controls.characterCount" [inputText]="formText.characterCount" [readonly]="isReadOnly$ | async"></coso-text-input>
} @if (formGroup.controls.pattern.value == SiteRule.StartingNameChars) {
<coso-text-input type="text" [control]="formGroup.controls.unknownCharacter" [inputText]="formText.unknownCharacter" [readonly]="isReadOnly$ | async"></coso-text-input>
}

<ng-template #characterCountPopover>
  The number of starting characters from the record's {{ formGroup.controls.pattern.value == SiteRule.StartingNameChars ? "name" : "id" }} of the record used to create the site name. The default value
  is 1.
</ng-template>

<ng-template #siteNamingRulePopover>
  <p>The structure or pattern used to get (or create) a site in SharePoint.</p>
  <p class="text-primary">
    In case the <code class="text-primary">getSite()</code> function is implemented and returns a non-empty value, it will override the configuration for any other rule you select, because it has
    higher precedence.
  </p>
  <p><strong>None:</strong> This rule will get the default SharePoint site in Dynamics 365.</p>
  <p><strong>Period:</strong> This rule will get (or create) a site based on a specific time period (year, quarter, month, week, day or custom).</p>
  <p><strong>Per entity:</strong> This rule will get (or create) a site per entity (if one does not exist).</p>
  <p><strong>Starting name characters:</strong> This rule will get (or create) a site based on the starting characters of the record’s name.</p>
  <p><strong>Starting Id characters:</strong> This rule will get (or create) a site based on the starting characters of the record’s id.</p>
  <p><strong>Per record:</strong> This rule will get (or create) a site per Dynamics 365 record, so it will most likely create more sites than the previous rules.</p>
  <p><strong>Custom script:</strong> This rule will get (or create) a site based on your LUA script. Implement <code class="text-primary">getSite()</code> function.</p>
</ng-template>

<ng-template #webTemplatePopover>
  <p>The site template used to create a site in SharePoint. The default value is STS#0 (Classic Team Site).</p>
  Examples:
  <ul>
    <li>STS#1 (Blank Site)</li>
    <li>STS#3 (Team site)</li>
  </ul>
  Find available web templates under the following link: <code class="text-primary">{{ WebTemplateApiEndpoint }}</code>
</ng-template>

<ng-template #periodPopover>
  <p>The time period used to create the site.</p>
  <p><strong>Day and month:</strong> The format for this time period iss {{ "{year}-{month}-{day}" }}.</p>
  <p><strong>Day:</strong> The format for this time period is {{ "{year}-{day}" }}.</p>
  <p><strong>Week:</strong> The format for this time period is {{ "{year}-W{week}" }}.</p>
  <p><strong>Month:</strong> The format for this time period is {{ "{year}-{month}" }}.</p>
  <p><strong>Quarter:</strong> The format for this time period is {{ "{year}-Q{quarter}" }}.</p>
  <p><strong>Year:</strong> The format for this time period is {{ "{year}" }}.</p>
  <p><strong>Custom:</strong> The format for this time period is very flexible.</p>
</ng-template>

<ng-template #periodSourcePopover>
  <p>The date used to create the site.</p>
  <p><strong>UTC Now (current date and time):</strong> The current date and time.</p>
  <p><strong>Create on (of D365 record):</strong> The Created-On attribute of the Dynamics 365 record.</p>
</ng-template>

<ng-template #siteNamePopover>
  The name of the site to be created. The following placeholders can be used: {{ "{0}" }} for entity name and {{ "{1}" }}
  @switch (formGroup.controls.pattern.value) { @default {
  <span>for the record's id.</span>
  } @case (SiteRule.Period) {
  <span>for date and time.</span>
  } @case (SiteRule.StartingNameChars) {
  <span>for 1 to n starting characters of the record's name.</span>
  } @case (SiteRule.StartingIdChars) {
  <span>for 1 to n starting characters of the record's id.</span>
  } }
</ng-template>
